import React from 'react'

import less from "../img/engadult.jpg";
// import teens from "../img/engadult1.jpg";

export default function Englishadult() {
  return (
    <div>
    <section className="jarallax dark-mode bg-dark py-5" datajarallax dataspeed="0.6">
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-60"></div>
    <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/engadult.JPG'}}></div>
    <div className="container position-relative zindex-2 pt-5 pb-md-2 pb-lg-3 pb-xl-4 pb-xxl-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
      <div className="d-none d-xxl-block" style={{height: "170px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "120px"}}></div>
      <div className="d-none d-md-block d-lg-none" sstyle={{height: "80px"}}></div>
      <div className="d-md-none" style={{height: "40px"}}></div>
      <h1 className="display-2 mb-4">Английский язык</h1>
      <p className="mb-0 lead text-white" 
    //   style={{maxWidth: "480px"}}
      >
      Изучение английского языка в современном мире играет важную роль не только в профессиональной сфере, но и в личной жизни. 
      <br/>Курсы английского языка от Центра развития «Форматы» предлагают качественное образование для различных категорий учащихся, начиная от тех, 
      кто планирует работать или учиться за границей, до тех, кто просто хочет свободно общаться и путешествовать по всему миру.
      <br/> 
      <p></p>
      Первое занятие – бесплатно для проведения собеседования и определения уровня знаний, освоения навыка. 
        </p>
      {/* Features*/}
      <div className="d-none d-xxl-block" style={{height: "220px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "160px"}}></div>
      <div className="d-none d-md-block d-lg-none" style={{height: "100px"}}></div>
      <div className="d-md-none" style={{height: "50px"}}></div>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 pb-1 pb-md-3">
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/time-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Индивидуальный подход</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/cog-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Интегрированная аналитика</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/monitor-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Будь на высоте</h3>
          </div>
        </div>
        {/* <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/size-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Полный спектр услуг: от мастер-классов до питание</h3>
          </div>
        </div> */}
      </div>
    </div>
  </section>

  <section className="container py-4 py-sm-5 my-md-2 my-lg-3 my-xl-4 my-xxl-5">
        <div className="row align-items-center py-4 py-xl-5 my-2">
          <div className="col-md-6 offset-xl-1 order-md-2 pb-2 mb-4 mb-md-0">
            {/* <img className="rounded-5" src={teens} alt="ImH"/>
            <p></p>
            <br/>
            <p></p> */}
            <img className="rounded-5" src={less} alt="ImH"/>
            {/* <p></p>
            <br/>
            <p></p>
            <img className="rounded-5" src={les} alt="ImH"/> */}
          </div>
          <div className="col-md-6 col-xl-5 order-md-1">
            <div className="pe-md-4 pe-xl-0">
              <h2 className=" pb-2 pb-lg-3">
                Обучение взрослых <br/>
                </h2>
              <p className="pb-2 pb-lg-0 mb-4 mb-lg-5 fs-lg">
              Курсы английского языка для современных и успешных!  <br/>
              Интенсивность: 2 раза в неделю по 60 минут 
              </p>
              <div className="row row-cols-1">
                <div className="col">
                  {/* <div className="d-table bg-secondary rounded-1 p-2 mb-3">
                  <img className="d-block d-dark-mode-none m-1" src="assets/img/services/v3/icons/monitor-dark.svg" width="28" alt="Icon"/>
                  <img className="d-none d-dark-mode-block m-1" src="assets/img/services/v3/icons/monitor-light.svg" width="28" alt="Icon"/>
                  </div> */}
                  <h3 className="h5 mb-2">Преимущества курсов английского языка от Центра развития «Форматы»: </h3>
                  <ul className="fs-lg mb-0">
                    <li><strong>Современные методики:</strong>Занятия проводятся в разговорном формате, что позволяет учащимся быстрее освоить навыки общения на английском языке.</li>
                    <li><strong>Опытные преподаватели: </strong> Преподаватели имеют высокую квалификацию и международный сертификат, что гарантирует высокий уровень преподавания.
                    </li>
                    <li><strong>Индивидуальный подход:</strong>Каждый ученик получает персональное внимание и возможность развивать свои навыки в комфортном темпе.</li>
                    <li><strong>Практическая направленность: </strong>Упор делается на практические навыки, такие как чтение, письмо, аудирование и говорение, что делает обучение более эффективным.</li>
                    <li><strong>Интерактивный формат:</strong>Разговорный клуб позволяет студентам практиковать английский язык в реальных ситуациях, улучшая их коммуникативные навыки.</li>
                     <li><strong>Бесплатное первое занятие: </strong>Новички могут попробовать свои силы и оценить уровень подготовки перед началом курса.</li>
                  </ul>
                </div> 
                <p></p>
                <div className="col">
                  <h3 className="h5 mb-2">Наши сильные преподаватели с Международной сертификацией: </h3>
                  <ul className="fs-lg mb-0">
                    <li>Елена Леонидовна – уровень владения языком на уровне С1, С2 (Advanced, Proficiency), стаж 20 лет.</li>
                    <li>Raymond - носитель языка, за границей преподавал в частной школе 3 года, в России преподает 5 года.</li>
                  </ul>
                  <p></p>
                  <h3 className="fs-lg mb-2"> Таким образом, курсы английского языка от Центра развития «Форматы» являются отличным выбором для тех, кто хочет улучшить свои знания английского языка и использовать их в повседневной жизни и карьере.
                   </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <div className="col">
              <h4 className="mb-lg-4">Подробности по Developskillsnow 
              <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/formatyou72"><i className="ai-telegram text-success"> </i> </a>
              <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/developskillsnow"><i className="ai-vk"> </i> </a> 
              <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/developskillsnow"><i className="ai-instagram text-warning"> </i> </a> 
              </h4>
              <a className="nav-link fs-lg mb-2" href="tel:+7 (992) 300-65-46"> <strong> Только по предварительной записи по телефону:  +7 (992) 300-65-46</strong></a>
              <a className="nav-link fs-lg mb-2" href="mailto:developskillsnow@yandex.ru"><strong>Наша эл.почта: developskillsnow@yandex.ru </strong> </a>
        </div>
       
      </section>
  </div>
  )
}
